import { createContext, useState, useCallback } from 'react';
import zhTW from '../locales/zh-TW.json';
import en from '../locales/en.json';

const translations = { 'zh-TW': zhTW, en };

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(
    () => localStorage.getItem('lang') || 'en'
  );

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem('lang', lang);
  }, []);

  const t = useCallback((key, params) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    if (value === undefined) {
      let fallback = translations['zh-TW'];
      for (const k of keys) {
        fallback = fallback?.[k];
      }
      value = fallback ?? key;
    }
    if (params && typeof value === 'string') {
      return value.replace(/\{(\w+)\}/g, (_, name) => params[name] ?? '');
    }
    return value;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
